import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import { CardStatus } from '@/constants/common';

dayjs.extend(relativeTime);

export const getStatusColor = ($status?: CardStatus) => {
  switch ($status) {
    case CardStatus.APPROVED:
      return 'var(--system-green)';
    case CardStatus.REJECTED:
      return 'var(--system-red)';
    case CardStatus.PENDING:
    case CardStatus.AWAITING_PAYMENT:
      return 'var(--textAndLabels-quaternary)';
    case CardStatus.EXPIRED:
      return 'var(--textAndLabels-tertiary)';
    default:
      return 'inherit';
  }
};

export const getStatus = ($status?: CardStatus) => {
  switch ($status) {
    case CardStatus.APPROVED:
      return 'Card.status_online';
    case CardStatus.REJECTED:
      return 'Card.status_rejected';
    case CardStatus.PENDING:
      return 'Card.status_checking';
    case CardStatus.EXPIRED:
      return 'Card.status_expired';
    case CardStatus.AWAITING_PAYMENT:
      return 'Card.status_awaiting_payment';
    default:
      return '';
  }
};

export const getProgress = (daysLeft: number) =>
  Math.min((daysLeft / 30) * 100, 100);
